import styled from 'styled-components';
import { ModernStyle } from 'styles/ModernStyle.styled';

export const DeleteAccountFormWrapper = styled(ModernStyle)`
    display: flex;
    flex-direction: column;
    max-width: 600px;
    padding-bottom: 32px;
`;
